import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import axios from "axios"
import { RootState } from "@/store"
import { TwoFactorAuthState } from "@/store/two-factor-auth/types"
import { TwoFactorEnrollment, TwoFactorStatus, twoFactorEndpoints } from "@/types/two-factor-auth"

const state: TwoFactorAuthState = {
    status: null,
    enrollment: null,
}

const mutations: MutationTree<TwoFactorAuthState> = {
    setStatus(state, status: TwoFactorStatus | null) {
        state.status = status
    },
    setEnrollment(state, enrollment: TwoFactorEnrollment | null) {
        state.enrollment = enrollment
    },
}

const actions: ActionTree<TwoFactorAuthState, RootState> = {
    async fetchStatus({ commit }) {
        const res = await axios.get(twoFactorEndpoints.status)
        commit("setStatus", res.data.data)
    },
    async startSetup({ commit }) {
        commit("setEnrollment", null)
        const res = await axios.post(twoFactorEndpoints.enrollments)
        commit("setEnrollment", res.data.data)
    },
    cancelSetup({ commit }) {
        commit("setEnrollment", null)
    },
    async enable({ commit, dispatch, state }, code: string) {
        if (!state.enrollment) return
        await axios.post(twoFactorEndpoints.activation(state.enrollment.id), { data: { code } })
        commit("setEnrollment", null)
        await dispatch("fetchStatus")
    },
    async disable({ dispatch }, code: string) {
        await axios.post(twoFactorEndpoints.deactivation, { data: { code } })
        await dispatch("fetchStatus")
    },
}

const getters: GetterTree<TwoFactorAuthState, RootState> = {
    status: ({ status }) => status,
    isEnabled: ({ status }) => !!status?.enabled,
    enrollment: ({ enrollment }) => enrollment,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<TwoFactorAuthState, RootState>
